module.exports = __webpack_public_path__ + "static/media/Office_1_t.241443b1.jpg";